/* eslint-disable no-loop-func */
/* eslint-disable no-restricted-imports */
import React, { useEffect, useState, useCallback, useRef } from "react";
import ReactToPrint, {
  PrintContextConsumer,
  useReactToPrint
} from "react-to-print";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import DatePicker from "react-datepicker";
import * as moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { Button } from "@material-ui/core";
import { Spinner } from "react-bootstrap";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { getLoggerStats } from "../modules/Auth/_redux/adminCrud";
import { CSVLink, CSVDownload } from "react-csv";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Line } from "react-chartjs-2";
import { random } from "lodash";

export function ChartPage() {
  const useStyles = makeStyles(theme => ({
    buttonStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1.2rem",
      marginRight: "12px"
    },
    buttonClearStyle: {
      width: "32px",
      height: "32px",
      border: "0px solid #123456",
      marginRight: "12px",
      "&:hover": {
        backgroundColor: "transparent !important"
      }
    },
    searchStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem",
      float: "right"
    },
    dateStyle: {
      width: "160px",
      height: "32px",
      color: "#123456",
      border: "1px solid #c8cace",
      fontSize: "1rem",
      marginRight: "36px",
      textAlign: "left",
      background: "transparent",
      borderRadius: "4px 4px 4px 4px",
      paddingLeft: "12px"
    },

    boxContainer: {
      display: "inline-block",
      width: "100%",
      verticalAlign: "top"
    },
    box30Style: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    boxStyle: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    boxInnerStyle: {
      width: "100%",
      display: "inline-block",
      background: "white"
      // border: "1px solid lightgray",
      // padding: "24px",
      // marginBottom: "12px"
    },
    subTitleStyle: {
      display: "flex",
      fontSize: "1.2rem",
      marginBottom: "12px",
      fontWeight: "bold",
      color: "#555555"
    },
    subTitleLastStyle: {
      fontSize: "1.2rem",
      fontWeight: "bold",
      color: "#555555",
      marginTop: "-8px"
    },
    headerRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px"
    },
    headerColStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "50%",
      background: "#dfe2e8",
      height: "44px"
    },
    dataRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px",
      borderBottom: "1px solid lightgray"
    },
    dataCol30Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      width: "30%",
      height: "44px"
    },
    dataColStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "50%",
      height: "44px"
    },
    dataColSmallStyle: {
      display: "inline-block",
      fontSize: "12px",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "hidden",
      lineHeight: "16px",
      paddingTop: "6px"
    },
    dataColTextStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      //   width: "50%",
      height: "44px"
    },
    radioStyle: {
      width: "80px",
      fontSize: "1rem",
      //   background: "transparent",
      color: "#555555",
      borderColor: "#dfe2e8",
      //   paddingTop: "6px",
      //   "&:hover": {
      //     color: "#123456",
      //     backgroundColor: "#eae4f5 !important"
      //   },
      "&:active": {
        color: "white",
        backgroundColor: "#123456 !important"
      }
    },
    selected: {
      color: "white",
      backgroundColor: "#123456 !important"
    }
  }));

  const Styles = useStyles();
  const componentRef = useRef();

  /* "fd.csv"
      "cpu.csv"
      "io.csv"
      "io-x.csv"
      "mysql.csv"
      "mtaqueue.csv"
      "proc.csv"
      "vm.csv"
      "nginx.csv"
      "df.csv"
      "zmstatuslog"
      "zmmtastats" */
  const [chartType, setChartType] = useState("zmmtastats");
  const [csvData, setCsvData] = useState([]);

  const initStartDate = () => {
    const start = new Date();

    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    return start;
  };

  const initEndDate = () => {
    const end = new Date();

    end.setHours(23);
    end.setMinutes(59);
    end.setSeconds(59);
    return end;
  };

  const [startDate, setStartDate] = useState(initStartDate());
  const [endDate, setEndDate] = useState(initEndDate());
  const [startDateStr, setStartDateStr] = useState("");
  const [endDateStr, setEndDateStr] = useState("");

  const setStartDateMem = millis => {
    sessionStorage.setItem("START_DATE", millis + "");
  };

  const getStartDateMem = () => {
    const a =
      sessionStorage.getItem("START_DATE") || initStartDate().getTime() + "";
    return parseInt(a, 10);
  };

  const setEndDateMem = millis => {
    sessionStorage.setItem("END_DATE", millis + "");
  };

  const getEndDateMem = () => {
    const a =
      sessionStorage.getItem("END_DATE") || initStartDate().getTime() + "";
    return parseInt(a, 10);
  };

  const setTermType = type => {
    sessionStorage.setItem("TERM_TYPE", type + "");
  };

  const getTermType = () => {
    const a = sessionStorage.getItem("TERM_TYPE") || "0";
    return parseInt(a, 10);
  };

  const setPerType = type => {
    sessionStorage.setItem("PER_TYPE", type + "");
  };

  const getPerType = () => {
    const a = sessionStorage.getItem("PER_TYPE") || "0";
    return parseInt(a, 10);
  };

  const [loading, setLoading] = useState(false);

  const headers = [
    "날짜",
    "filter_misc",
    "clam_events",
    "mta_delay",
    "mta_volume",
    "filter_virus",
    "filter_count",
    "mta_count",
    "filter_spam",
    "sendmail_event"
  ];

  const [labels, set_labels] = useState([]);
  const [filter_misc, set_filter_misc] = useState([]);
  const [clam_events, set_clam_events] = useState([]);
  const [mta_delay, set_mta_delay] = useState([]);
  const [mta_volume, set_mta_volume] = useState([]);
  const [filter_virus, set_filter_virus] = useState([]);
  const [filter_count, set_filter_count] = useState([]);
  const [mta_count, set_mta_count] = useState([]);
  const [filter_spam, set_filter_spam] = useState([]);
  const [sendmail_events, set_sendmail_events] = useState([]);

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

  const [chartOptions, setChartOptions] = useState({
    responsive: true,
    plugins: {
      legend: {
        position: "top"
      },
      title: {
        display: false,
        text: "Chart.js Line Chart"
      }
    },
    scales: {
      y: {
        min: 0,
        max: 500
      }
    }
  });

  const [chartData, setChartData] = useState({
    // labels,
    // datasets: [
    //   {
    //     label: "Dataset 1",
    //     data: labels.map(() => min + Math.random() * (max - min)),
    //     borderColor: "rgb(255, 99, 132)",
    //     backgroundColor: "rgba(255, 99, 132, 0.5)"
    //   },
    //   {
    //     label: "Dataset 2",
    //     data: labels.map(() => min + Math.random() * (max - min)),
    //     borderColor: "rgb(53, 162, 235)",
    //     backgroundColor: "rgba(53, 162, 235, 0.5)"
    //   }
    // ]

    labels: [],
    datasets: []
  });

  const CustomDateInput = ({ value, onClick }) => (
    <>
      <button className={Styles.dateStyle} onClick={onClick}>
        {value}
      </button>
      <img
        src={toAbsoluteUrl("/media/images/btn_schedule.svg")}
        style={{
          marginLeft: "-68px"
        }}
        alt=""
      />
    </>
  );

  const setDateString = () => {
    setStartDateStr(moment(startDate).format("YYYY-MM-DD"));
    setEndDateStr(moment(endDate).format("YYYY-MM-DD"));

    console.log("START", moment(startDate).format("YYYY-MM-DD hh:mm:ss"));
    console.log("  END", moment(startDate).format("YYYY-MM-DD hh:mm:ss"));
  };

  const initDates = () => {
    const start = new Date();
    const end = new Date();

    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);

    end.setHours(23);
    end.setMinutes(59);
    end.setSeconds(59);

    setStartDate(start);
    setStartDateMem(start.getTime());
    setEndDate(end);
    setEndDateMem(start.getTime());
    setDateString();
  };

  const moveLeft = () => {
    if (getTermType() === 0) {
      const st = moment(startDate)
        .add(-1, "days")
        .toDate();
      const ed = moment(endDate)
        .add(-1, "days")
        .toDate();

      setStartDate(st);
      setStartDateMem(st.getTime());
      setEndDate(ed);
      setEndDateMem(ed.getTime());
    }
    if (getTermType() === 1) {
      const st = moment(startDate)
        .add(-7, "days")
        .toDate();
      const ed = moment(endDate)
        .add(-7, "days")
        .toDate();

      setStartDate(st);
      setStartDateMem(st.getTime());
      setEndDate(ed);
      setEndDateMem(ed.getTime());
    }
    if (getTermType() === 2) {
      const st = moment(startDate)
        .add(-1, "months")
        .toDate();
      const ed = moment(endDate)
        .add(-1, "months")
        .toDate();

      setStartDate(st);
      setStartDateMem(st.getTime());
      setEndDate(ed);
      setEndDateMem(ed.getTime());
    }
    if (getTermType() === 3) {
      const st = moment(startDate)
        .add(-3, "months")
        .toDate();
      const ed = moment(endDate)
        .add(-3, "months")
        .toDate();

      setStartDate(st);
      setStartDateMem(st.getTime());
      setEndDate(ed);
      setEndDateMem(ed.getTime());
    }

    setDateString();
  };
  const moveRight = () => {
    if (getTermType() === 0) {
      const st = moment(startDate)
        .add(1, "days")
        .toDate();
      const ed = moment(endDate)
        .add(1, "days")
        .toDate();

      setStartDate(st);
      setStartDateMem(st.getTime());
      setEndDate(ed);
      setEndDateMem(ed.getTime());
    }
    if (getTermType() === 1) {
      const st = moment(startDate)
        .add(7, "days")
        .toDate();
      const ed = moment(endDate)
        .add(7, "days")
        .toDate();

      setStartDate(st);
      setStartDateMem(st.getTime());
      setEndDate(ed);
      setEndDateMem(ed.getTime());
    }
    if (getTermType() === 2) {
      const st = moment(startDate)
        .add(1, "months")
        .toDate();
      const ed = moment(endDate)
        .add(1, "months")
        .toDate();

      setStartDate(st);
      setStartDateMem(st.getTime());
      setEndDate(ed);
      setEndDateMem(ed.getTime());
    }
    if (getTermType() === 3) {
      const st = moment(startDate)
        .add(3, "months")
        .toDate();
      const ed = moment(endDate)
        .add(3, "months")
        .toDate();

      setStartDate(st);
      setStartDateMem(st.getTime());
      setEndDate(ed);
      setEndDateMem(ed.getTime());
    }

    setDateString();
  };

  const setTermToday = useCallback(() => {
    setStartDate(endDate);
    setStartDateMem(endDate.getTime());
    setTermType(0);
    setDateString();
  }, [endDate, setDateString]);

  const setTermWeek = useCallback(() => {
    const m = moment(endDate).add(-7, "days");
    setStartDate(m.toDate());
    setStartDateMem(m.toDate().getTime());
    setTermType(1);
    setDateString();
  }, [endDate, setDateString]);

  const setTermMonth = useCallback(() => {
    const m = moment(endDate).add(-1, "months");
    setStartDate(m.toDate());
    setStartDateMem(m.toDate().getTime());
    setTermType(2);
    setDateString();
  }, [endDate, setDateString]);
  const setTerm3Month = useCallback(() => {
    const m = moment(endDate).add(-3, "months");
    setStartDate(m.toDate());
    setStartDateMem(m.toDate().getTime());
    setTermType(3);
    setDateString();
  }, [endDate, setDateString]);

  const average = (label, array) => {
    let avg = 0;

    if (array == null || array.length === 0) return 0;
    array.map(a => (avg += a));
    // for(var ii = 0; ii < array.length; ii += 1)
    // console.log('average', label, array.length, array)
    // return Math.floor(avg / array.length);
    return avg;
  };

  const parse = value => {
    if (value === "") return 0;

    return parseInt(value, 10);
  };

  const maximum = array => {
    let max = 0;
    array.forEach(a => {
      // if (a > 0) console.log("maximum", array.length, a);
      if (max < a) max = a;
    });

    return max;
  };

  const searchStats = () => {
    console.log(
      "searchStats",
      chartType,
      getTermType(),
      getPerType(),
      moment(getStartDateMem()).format("YYYY-MM-DD hh:mm:ss"),
      moment(getEndDateMem()).format("YYYY-MM-DD hh:mm:ss")
    );

    let labels = [];
    let tmp_filter_misc = [];
    let tmp_clam_events = [];
    let tmp_mta_delay = [];
    let tmp_mta_volume = [];
    let tmp_filter_virus = [];
    let tmp_filter_count = [];
    let tmp_mta_count = [];
    let tmp_filter_spam = [];
    let tmp_sendmail_events = [];
    let datasets = [];

    setLoading(true);

    getLoggerStats(
      chartType,
      Math.floor(getStartDateMem() / 1000) + "",
      Math.floor(getEndDateMem() / 1000) + ""
    ).then(result => {
      console.log("getLoggerStats", result);
      if (result.data.loggerStats.hostname != null) {
        result.data.loggerStats.hostname.forEach(host => {
          console.log("   Host", host);
          host.stats.forEach(stat => {
            console.log("    Name", stat.name);
            // console.log("Values Count", stat.values.length);

            let bfr_filter_misc = [];
            let bfr_clam_events = [];
            let bfr_mta_delay = [];
            let bfr_mta_volume = [];
            let bfr_filter_virus = [];
            let bfr_filter_count = [];
            let bfr_mta_count = [];
            let bfr_filter_spam = [];
            let bfr_sendmail_events = [];

            let prevDate = null;
            // const fmtMonth = "YYYY-MM";
            // const fmtDay = "YYYY-MM-DD";
            // const fmtHour = "YYYY-MM-DD hh";
            const fmtMonth = "MM월";
            const fmtDay = "MM월 DD일";
            const fmtHour = "MM월 DD일 hh시";
            let fmt;
            if (getPerType() === 0) fmt = fmtMonth;
            else if (getPerType() === 1) fmt = fmtDay;
            else if (getPerType() === 2) fmt = fmtHour;

            // stat.values.forEach(value => {
            for (var ii = 0; ii < stat.values?.length; ii += 1) {
              const value = stat.values[ii];
              const tsMills = value.t;
              const tm = moment.unix(tsMills).toDate();
              const ts = moment.unix(tsMills).format(fmt);
              let changed = false;

              if (prevDate == null) {
                labels.push(ts);
              } else {
                // console.log('XXX', ts, prevDate.getMonth(),  tm.getMonth())
                if (
                  getPerType() === 0 &&
                  prevDate.getMonth() !== tm.getMonth()
                ) {
                  changed = true;
                } else if (
                  getPerType() === 1 &&
                  prevDate.getDate() !== tm.getDate()
                ) {
                  changed = true;
                } else if (
                  getPerType() === 2 &&
                  prevDate.getHours() !== tm.getHours()
                ) {
                  changed = true;
                }
              }

              prevDate = tm;

              if (changed) {
                labels.push(ts);

                tmp_filter_misc.push(average("filter_misc", bfr_filter_misc));
                tmp_clam_events.push(average("clam_events", bfr_clam_events));
                tmp_mta_delay.push(average("mta_delay", bfr_mta_delay));
                tmp_mta_volume.push(average("mta_volume", bfr_mta_volume));
                tmp_filter_virus.push(
                  average("filter_virus", bfr_filter_virus)
                );
                tmp_filter_count.push(
                  average("filter_count", bfr_filter_count)
                );
                tmp_mta_count.push(average("mta_count", bfr_mta_count));
                tmp_filter_spam.push(average("filter_spam", bfr_filter_spam));
                tmp_sendmail_events.push(
                  average("sendmail_events", bfr_sendmail_events)
                );

                bfr_filter_misc = [];
                bfr_clam_events = [];
                bfr_mta_delay = [];
                bfr_mta_volume = [];
                bfr_filter_virus = [];
                bfr_filter_count = [];
                bfr_mta_count = [];
                bfr_filter_spam = [];
                bfr_sendmail_events = [];
              }

              value.stat.forEach(st => {
                // console.log("INFO", ts, st.name, st.value);

                if (st.name === "filter_misc")
                  bfr_filter_misc.push(parse(st.value));
                if (st.name === "clam_events")
                  bfr_clam_events.push(parse(st.value));
                if (st.name === "mta_delay")
                  bfr_mta_delay.push(parse(st.value));
                if (st.name === "mta_volume")
                  bfr_mta_volume.push(parse(st.value));
                if (st.name === "filter_virus")
                  bfr_filter_virus.push(parse(st.value));
                if (st.name === "filter_count")
                  bfr_filter_count.push(parse(st.value));
                if (st.name === "mta_count")
                  bfr_mta_count.push(parse(st.value));
                if (st.name === "filter_spam")
                  bfr_filter_spam.push(parse(st.value));
                if (st.name === "sendmail_events")
                  bfr_sendmail_events.push(parse(st.value));
              });
            }

            // 마지막 월/일/시간 단위
            tmp_filter_misc.push(average("filter_misc", bfr_filter_misc));
            tmp_clam_events.push(average("clam_events", bfr_clam_events));
            tmp_mta_delay.push(average("mta_delay", bfr_mta_delay));
            tmp_mta_volume.push(average("mta_volume", bfr_mta_volume));
            tmp_filter_virus.push(average("filter_virus", bfr_filter_virus));
            tmp_filter_count.push(average("filter_count", bfr_filter_count));
            tmp_mta_count.push(average("mta_count", bfr_mta_count));
            tmp_filter_spam.push(average("filter_spam", bfr_filter_spam));
            tmp_sendmail_events.push(
              average("sendmail_events", bfr_sendmail_events)
            );
          });
        });

        set_labels(labels);
        set_filter_misc(tmp_filter_misc);
        set_clam_events(tmp_clam_events);
        set_mta_delay(tmp_mta_delay);
        set_mta_volume(tmp_mta_volume);
        set_filter_virus(tmp_filter_virus);
        set_filter_count(tmp_filter_count);
        set_mta_count(tmp_mta_count);
        set_filter_spam(tmp_filter_spam);
        set_sendmail_events(tmp_sendmail_events);

        datasets.push({
          label: "filter_misc",
          data: tmp_filter_misc,
          borderColor: "rgb(255, 99, 132)",
          backgroundColor: "rgba(255, 99, 132, 0.5)"
        });
        datasets.push({
          label: "clam_events",
          data: tmp_clam_events,
          borderColor: "rgb(53, 162, 235)",
          backgroundColor: "rgba(53, 162, 235, 0.5)"
        });
        datasets.push({
          label: "mta_delay",
          data: tmp_mta_delay,
          borderColor: "rgb(255, 142, 0)",
          backgroundColor: "rgb(255, 142, 0, 0.5)"
        });
        datasets.push({
          label: "mta_volume",
          data: tmp_mta_volume,
          borderColor: "rgb(255, 228, 0)",
          backgroundColor: "rgb(255, 228, 0, 0.5)"
        });
        datasets.push({
          label: "filter_virus",
          data: tmp_filter_virus,
          borderColor: "rgb(255, 99, 132)",
          backgroundColor: "rgba(255, 99, 132, 0.5)"
        });
        datasets.push({
          label: "filter_count",
          data: tmp_filter_count,
          borderColor: "rgb(6, 255, 0)",
          backgroundColor: "rgb(6, 255, 0, 0.5)"
        });
        datasets.push({
          label: "mta_count",
          data: tmp_mta_count,
          borderColor: "rgb(103, 137, 131)",
          backgroundColor: "rgb(103, 137, 131, 0.5)"
        });
        datasets.push({
          label: "filter_spam",
          data: tmp_filter_spam,
          borderColor: "rgb(156, 25, 224)",
          backgroundColor: "rgb(156, 25, 224, 0.5)"
        });
        datasets.push({
          label: "sendmail_events",
          data: tmp_sendmail_events,
          borderColor: "rgb(153, 221, 204)",
          backgroundColor: "rgb(153, 221, 204, 0.5)"
        });

        const aggr = [
          maximum(tmp_filter_misc),
          maximum(tmp_filter_misc),
          maximum(tmp_clam_events),
          maximum(tmp_mta_delay),
          maximum(tmp_mta_volume),
          maximum(tmp_filter_virus),
          maximum(tmp_filter_count),
          maximum(tmp_mta_count),
          maximum(tmp_filter_spam),
          maximum(tmp_sendmail_events)
        ];

        let max = maximum(aggr);
        console.log("MAX", max, aggr, tmp_mta_volume);
        console.log("LABEL", labels);

        if (max > 0) {
          chartOptions.scales.y = {
            min: 0,
            max: Math.floor(max * 1.1)
          };
          setChartOptions(chartOptions);
        }
        setChartData({
          labels,
          datasets
        });

        const data = [];
        labels.map((label, index) => {
          data.push([
            label,
            tmp_filter_misc[index] + "",
            tmp_clam_events[index] + "",
            tmp_mta_delay[index] + "",
            tmp_mta_volume[index] + "",
            tmp_filter_virus[index] + "",
            tmp_filter_count[index] + "",
            tmp_mta_count[index] + "",
            tmp_filter_spam[index] + "",
            tmp_sendmail_events[index] + ""
          ]);
        });

        // console.log("CSV", data);
        setCsvData(data);

        setLoading(false);
      }
    })
    .catch(error => {
      console.log(error)
    })
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  });

  useEffect(() => {
    setPerType(0);
    setTermType(0);

    initDates();
    searchStats();
  }, []);

  // useEffect(() => {}, [
  //   chartType,
  //   chartData,
  //   endDate,
  //   startDate,
  //   setChartType,
  //   setTermToday,
  //   setTermWeek,
  //   setTermMonth,
  //   setTerm3Month,
  // ]);

  return (
    <>
      {loading ? (
        <div style={{ width: "100%", height: "100%" }}>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            style={{ margin: "40% 50% 30% 50%", width: "24px", height: "24px" }}
          />
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <div
          style={{
            marginTop: "12px",
            marginLeft: "-12px",
            height: "100%"
          }}
        >
          {/* -------------------- */}

          <div className={Styles.boxStyle}>
            <div className={Styles.subTitleStyle}>
              <Button className={Styles.buttonStyle}>
                <CSVLink
                  headers={headers}
                  data={csvData}
                  filename={`메일통계-${moment(startDate).format(
                    "YYYYMMDDhhmmss"
                  )}.xls`}
                >
                  저장
                </CSVLink>
              </Button>
              <ReactToPrint
                content={() => componentRef.current}
                documentTitle={`메일통계-${moment(startDate).format(
                  "YYYYMMDDhhmmss"
                )}`}
                pageStyle={{
                  padding: "300px 24px 48px 24px"
                }}
              >
                <PrintContextConsumer>
                  {({ handlePrint }) => (
                    <Button
                      onClick={handlePrint}
                      className={Styles.buttonStyle}
                    >
                      인쇄
                    </Button>
                  )}
                </PrintContextConsumer>
              </ReactToPrint>
            </div>

            <div className={Styles.boxInnerStyle} ref={componentRef}>
              {/* <div className={Styles.subTitleStyle}>
              통계 종류
              <Select
                value={chartType}
                className={Styles.selectStyle}
                onChange={e => {
                  setChartType(e.target.value);
                  searchStats();
                }}
                style={{
                  width: "182px",
                  marginTop: "-3px",
                  fontSize: "1.2rem",
                  marginLeft: "12px"
                }}
              >
                <MenuItem value="cpu">CPU 사용량</MenuItem>
                <MenuItem value="io">입출력</MenuItem>
                <MenuItem value="io-x">입출력 확장</MenuItem>
                <MenuItem value="mtaqueue">MTA 큐</MenuItem>
                <MenuItem value="vm">가상머신</MenuItem>
                <MenuItem value="nginx.csv">웹서비스</MenuItem>
                <MenuItem value="zmstatuslog">서비스 상태</MenuItem>
                <MenuItem value="zmmtastats">MTA 통계</MenuItem>
              </Select>
            </div> */}

              <div className={Styles.subTitleStyle}>
                <DatePicker
                  selected={startDate}
                  dateFormat="yyyy/MM/dd"
                  onChange={date => {
                    date.setHours(0);
                    date.setMinutes(0);
                    date.setSeconds(0);
                    setStartDate(date);
                    setStartDateMem(date.getTime());
                  }}
                  customInput={<CustomDateInput />}
                />
                <span> &nbsp;&nbsp;&nbsp;~ &nbsp;&nbsp;&nbsp;</span>
                <DatePicker
                  selected={endDate}
                  dateFormat="yyyy/MM/dd"
                  onChange={date => {
                    date.setHours(23);
                    date.setMinutes(59);
                    date.setSeconds(59);
                    setEndDate(date);
                    setEndDateMem(date.getTime());
                  }}
                  customInput={<CustomDateInput />}
                />

                <ToggleButtonGroup
                  type="radio"
                  defaultValue={[1]}
                  name="Uncontrolled"
                  style={{
                    height: "32px",
                    display: "inline-flex",
                    marginLeft: "24px"
                  }}
                  // classes={{ selected: Styles.selected }}
                >
                  <ToggleButton
                    // value={1}
                    className={[
                      Styles.radioStyle,
                      getTermType() === 0 && Styles.selected
                    ]}
                    onClick={() => {
                      setTermToday();
                      searchStats();
                    }}
                  >
                    오늘
                  </ToggleButton>
                  <ToggleButton
                    // value={2}
                    className={[
                      Styles.radioStyle,
                      getTermType() === 1 && Styles.selected
                    ]}
                    onClick={() => {
                      setTermWeek();
                      searchStats();
                    }}
                  >
                    7일
                  </ToggleButton>
                  <ToggleButton
                    // value={3}
                    className={[
                      Styles.radioStyle,
                      getTermType() === 2 && Styles.selected
                    ]}
                    onClick={() => {
                      setTermMonth();
                      searchStats();
                    }}
                  >
                    한달
                  </ToggleButton>
                  <ToggleButton
                    // value={4}
                    className={[
                      Styles.radioStyle,
                      getTermType() === 3 && Styles.selected
                    ]}
                    onClick={() => {
                      setTerm3Month();
                      searchStats();
                    }}
                  >
                    3개월
                  </ToggleButton>
                </ToggleButtonGroup>

                <ToggleButtonGroup
                  type="radio"
                  defaultValue={[1]}
                  name="Uncontrolled"
                  style={{
                    height: "32px",
                    display: "inline-flex",
                    marginLeft: "24px"
                  }}
                  // classes={{ selected: Styles.selected }}
                >
                  <ToggleButton
                    className={[
                      Styles.radioStyle,
                      getPerType() === 0 && Styles.selected
                    ]}
                    onClick={() => {
                      setPerType(0);
                      searchStats();
                    }}
                  >
                    월별
                  </ToggleButton>
                  <ToggleButton
                    className={[
                      Styles.radioStyle,
                      getPerType() === 1 && Styles.selected
                    ]}
                    onClick={() => {
                      setPerType(1);

                      searchStats();
                    }}
                  >
                    일별
                  </ToggleButton>
                  <ToggleButton
                    className={[
                      Styles.radioStyle,
                      getPerType() === 2 && Styles.selected
                    ]}
                    onClick={() => {
                      setPerType(2);
                      searchStats();
                    }}
                  >
                    시간별
                  </ToggleButton>
                </ToggleButtonGroup>
                <span>&nbsp;&nbsp;&nbsp;</span>

                {/* <Button className={Styles.searchStyle} onClick={searchStats}>
                조회
              </Button> */}
              </div>

              <div className={Styles.subTitleLastStyle}>
                {/* <span>
                {startDateStr} ~ {endDateStr}
              </span> */}
                <Button
                  className={Styles.buttonClearStyle}
                  onClick={() => {
                    moveLeft();
                    searchStats();
                  }}
                >
                  <img
                    src={toAbsoluteUrl(
                      "/media/images/icon_address_arrow_left.svg"
                    )}
                    alt=""
                  />
                </Button>
                <Button
                  className={Styles.buttonClearStyle}
                  onClick={() => {
                    moveRight();
                    searchStats();
                  }}
                >
                  <img
                    src={toAbsoluteUrl(
                      "/media/images/icon_address_arrow_right.svg"
                    )}
                    alt=""
                  />
                </Button>
              </div>

              <Line options={chartOptions} data={chartData} />

              <div className={Styles.headerRowStyle}>
                <div className={Styles.headerColStyle}>날짜</div>
                <div className={Styles.headerColStyle}>filter_misc</div>
                <div className={Styles.headerColStyle}>clam_events</div>
                <div className={Styles.headerColStyle}>mta_delay</div>
                <div className={Styles.headerColStyle}>mta_volume</div>
                <div className={Styles.headerColStyle}>filter_virus</div>
                <div className={Styles.headerColStyle}>filter_count</div>
                <div className={Styles.headerColStyle}>mta_count</div>
                <div className={Styles.headerColStyle}>filter_spam</div>
                <div className={Styles.headerColStyle}>sendmail_events</div>
              </div>

              {labels.map((label, index) => (
                <div className={Styles.dataRowStyle} key={uuidv4()}>
                  <div className={Styles.dataColStyle}>{label}</div>
                  <div className={Styles.dataColStyle}>
                    {filter_misc[index]}
                  </div>
                  <div className={Styles.dataColStyle}>
                    {clam_events[index]}
                  </div>
                  <div className={Styles.dataColStyle}>{mta_delay[index]}</div>
                  <div className={Styles.dataColStyle}>{mta_volume[index]}</div>
                  <div className={Styles.dataColStyle}>
                    {filter_virus[index]}
                  </div>
                  <div className={Styles.dataColStyle}>
                    {filter_count[index]}
                  </div>
                  <div className={Styles.dataColStyle}>{mta_count[index]}</div>
                  <div className={Styles.dataColStyle}>
                    {filter_spam[index]}
                  </div>
                  <div className={Styles.dataColStyle}>
                    {sendmail_events[index]}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
